import {FrontendRequest} from "services-comun/modules/net/request-frontend";
import {logRejection} from "services-comun/modules/decorators/metodo";

import dominio from "../../portal/ed";

export class RecursosWebFrontendRequest extends FrontendRequest {
    /* STATIC */
    private static SERVICIO: string = dominio.get(dominio.SERVICES);

    @logRejection(true)
    public static async uploadImage(files: FormData): Promise<any> {
        try {
            const data = await fetch(`${this.SERVICIO}/web/upload/image/`, {method: 'POST', body: files});
            const json = await data.json();
            return json.data;
        } catch (e) {}
    }

    /* INSTANCE */
}
